module.exports = __webpack_public_path__ + "img/c04_buildingstartechblotoutthesun_Normal_ua.8374d7f6.webp";